import { getEnv } from 'common-nextjs';

const remarketingHtml = {
  __html: `\
/* <![CDATA[ */
var google_conversion_id = ${getEnv('GOOGLE_REMARKETING_CONVERSION_ID')};
var google_custom_params = window.google_tag_params;
var google_remarketing_only = true;
/* ]]> */`,
};

const gtagHtml = {
  __html: `\
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}`,
};

const GA4_TRACKING_ID = getEnv('GA4_TRACKING_ID');
const GOOGLE_REMARKETING_CONVERSION_ID = getEnv(
  'GOOGLE_REMARKETING_CONVERSION_ID',
);

export default function GoogleAnalyticsScripts() {
  return (
    <>
      <script async type="text/javascript" dangerouslySetInnerHTML={gtagHtml} />

      {GA4_TRACKING_ID && (
        <script
          async
          type="text/javascript"
          src={`https://www.googletagmanager.com/gtag/js?id=${GA4_TRACKING_ID}`}
        />
      )}

      {GOOGLE_REMARKETING_CONVERSION_ID && (
        <script
          async
          type="text/javascript"
          dangerouslySetInnerHTML={remarketingHtml}
        />
      )}
    </>
  );
}
